import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  registerLocalRequest: ['local'],
  registerLocalSuccess: null,

  updateLocalRequest: ['local', 'values'],
  updateLocalSuccess: null,

  getAllLocalRequest: null,
  getAllLocalSuccess: ['locais'],

  deleteLocalRequest: ['id'],
  deleteLocalSuccess: null,

  requestLocalFailure: ['error'],
});

const INITIAL_STATE = { locais: [], loading: false, error: '' };

/**
 * REGISTER REQUESTS BELLOW
 */

const registerLocalRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const registerLocalSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * UPDATE REQUESTS BELLOW
 */

const deleteLocalRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const deleteLocalSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});
/**
 * UPDATE REQUESTS BELLOW
 */

const updateLocalRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
});

const updateLocalSuccess = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: false,
});

/**
 * GET SERVICES
 */

const getAllLocalRequest = (state = INITIAL_STATE) => ({
  ...state,
  error: '',
  loading: true,
  locais: [],
});

const getAllLocalSuccess = (state = INITIAL_STATE, action) => ({
  ...state,
  error: '',
  loading: false,
  locais: action.locais,
});

/**
 * Request falure
 */
const requestLocalFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  error: action.error,
  loading: false,
});

export default createReducer(INITIAL_STATE, {
  [Types.REGISTER_LOCAL_REQUEST]: registerLocalRequest,
  [Types.REGISTER_LOCAL_SUCCESS]: registerLocalSuccess,

  [Types.REQUEST_LOCAL_FAILURE]: requestLocalFailure,

  [Types.UPDATE_LOCAL_REQUEST]: updateLocalRequest,
  [Types.UPDATE_LOCAL_SUCCESS]: updateLocalSuccess,

  [Types.DELETE_LOCAL_REQUEST]: deleteLocalRequest,
  [Types.DELETE_LOCAL_SUCCESS]: deleteLocalSuccess,

  [Types.GET_ALL_LOCAL_REQUEST]: getAllLocalRequest,
  [Types.GET_ALL_LOCAL_SUCCESS]: getAllLocalSuccess,
});
